import './styles/muiV5ClassPrefix';
import React from 'react';
import { hydrate } from 'react-dom';
import { createBrowserHistory } from 'history';
import webFontLoader from 'webfontloader';
import AppContainer from './containers/AppContainer';
import { hideError, hideNeedLoging } from 'actions/actions';
import { initializeStore } from 'store/createStore';
import { initRestApi } from 'infrastructure/ServiceLocator';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import DomainManager from './utils/domain.js';
import moment from 'moment-timezone';
import { initializeAnalytics, wrapRenderWithErrorHandling } from './services/analytics/initializer';
import { initializeMomentLocalization } from './utils/translation';
import { initializeLocalization } from './utils/localizationHelper';

moment.tz.setDefault('UTC');

const browserHistory = createBrowserHistory();
const initialState = window.__INITIAL_STATE__;
delete window.__INITIAL_STATE__;
const store = initializeStore(initialState, browserHistory);

store.dispatch(hideError());
store.dispatch(hideNeedLoging());

initRestApi(store.dispatch, store.getState());

initializeMomentLocalization();
initializeLocalization(store);

webFontLoader.load({
  google: {
    families: ['Roboto:100,300,400,400i,700,700:cyrillic', 'Oswald:200,400:cyrillic&display=swap'],
  },
});

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById('root');

let render = () => {
  hydrate(<AppContainer store={store} browserHistory={browserHistory} />, MOUNT_NODE);
};

// This code is excluded from production bundle
if (__DEV__) {
  if (module.hot) {
    // Development render functions
    const renderApp = render;

    render = wrapRenderWithErrorHandling(renderApp, 'student', 'AppContainer');
  }
}

const domainManager = DomainManager(store, 'client');

window.initDomain = domainManager.initDomain;
window.initDomain(initialState, function () {
  const seoBody = document.getElementById('seo-body');
  if (seoBody) {
    seoBody.style.display = 'none';
  }
  const indexLoader = document.getElementById('index-loader');
  if (indexLoader) {
    indexLoader.parentNode.removeChild(indexLoader);
  }

  render();

  initializeAnalytics();
});
